// extracted by mini-css-extract-plugin
export var containerSlim = "ContainerSlim-module--containerSlim--9b723";